<mm-banners *ngIf="showErrorForGetRules" id="customRulesErrorBanner" [bannerText]="[serviceErrorMessage]" [type]="'error'"></mm-banners>
<div id="init-release-create-rule">
  <span class="section-title" id="init-release-transactions-header">
    Active Rules
  </span>
  <button (click)="onCreateRuleClicked()" class="sdps-button sdps-button--primary sdps-button--small create-rule"><span class="buttonText">Create Custom Rule</span></button>
  <mm-table 
    [columnDefs]="columnDefs"  
    [defaultColumnDefs]="defColumnDefs" 
    [rowHeight]="25" 
    [headerHeight]="25" 
    [showFilterCount]="true" 
    [rowData]="(rowData$ | async)"
    [tableName]="'create rule'" 
    [fileName]="'create rule'"
    [showFilterCount]="true" 
    [showFloatingFilter]="true" 
    [enableBrowserTooltips]="true"
    [componentState$]="createRuleTableState$">
  </mm-table>

</div>
<mm-init-release-create-rule-modal></mm-init-release-create-rule-modal>
<mm-init-release-delete-rule-modal></mm-init-release-delete-rule-modal>
